import { useTranslation } from 'react-i18next'
import { Breadcrumbs } from '@mui/material'

import { ArrowIcon } from 'src/assets/icons'
import { Item } from './item.component'
import { useScanRelationContext } from '../form-wrapper/relations-context.component'

import { useStyles } from './styles'
import { ECreateScanMode, ETranslationNs } from 'src/types'

export const ProgressSteps = () => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const classes = useStyles()
  const { relations, step, setStep, createScanMode } = useScanRelationContext()

  const handleClick = (step: number) => () => {
    setStep(step)
  }

  if (step === null) {
    return null
  }

  return (
    <div className={classes.container}>
      <Breadcrumbs className={classes.breadcrumbs} separator={<ArrowIcon />}>
        {(step >= 0 || relations.account) && (
          <Item
            label={relations.account ? t('scan-account-title.v') : undefined}
            onClick={handleClick(0)}
            title={relations.account?.account_holder || t('scan-account-title.v')}
            subtitle={relations.account?.address}
            image={relations.account?.image_small || relations.account?.image}
          />
        )}
        {(step >= 1 || relations.impact) && createScanMode === ECreateScanMode.AccountImpact && (
          <Item
            label={relations.impact ? t('scan-progress-impact-title.v') : undefined}
            onClick={handleClick(1)}
            title={relations.impact?.name || t('scan-product-title.v')}
            subtitle={relations.impact?.code && `#${relations.impact?.code}`}
            image={relations.impact?.image_small || relations.impact?.image}
          />
        )}

        {(step >= 1 || relations.product) && createScanMode !== ECreateScanMode.AccountImpact && (
          <Item
            label={relations.product ? t('scan-product-title.v') : undefined}
            onClick={handleClick(1)}
            title={relations.product?.name || t('scan-progress-product-or-impact-title.v')}
            subtitle={relations.product?.code && `#${relations.product?.code}`}
            image={relations.product?.image_small || relations.product?.image}
          />
        )}

        {(step >= 2 || relations.step) && createScanMode === ECreateScanMode.Default && (
          <Item
            label={relations.step ? t('scan-progress-step-title.v') : undefined}
            onClick={handleClick(2)}
            title={relations.step?.name || t('scan-step-title.v')}
            subtitle={relations.step?.code && `#${relations.step?.code}`}
            image={relations.step?.image_small || relations.step?.image}
          />
        )}
        {(step >= 2 || relations.impact) && createScanMode == ECreateScanMode.ProductImpact && (
          <Item
            label={relations.impact ? t('scan-progress-impact-title.v') : undefined}
            onClick={handleClick(2)}
            title={relations.impact?.name || t('scan-step-title.v')}
            subtitle={relations.impact?.code && `#${relations.impact?.code}`}
            image={relations.impact?.image_small || relations.impact?.image}
          />
        )}
        {(step >= 3 || relations.step) && (
          <Item onClick={handleClick(3)} title={t('scanner-details-form-breadcrumb.v')} />
        )}
      </Breadcrumbs>
    </div>
  )
}
